import { Button, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import config from "../../config";
import { dispatch } from "../../events";
import { types } from "../../events/loader";
import httpUtils from "../../utils/http.utils";
import AddComment from "./addComment";
import Comment from './comment';

const useStyles = makeStyles((theme) => ({
    messages: {
        height: '300px',
        overflow: 'scroll'
    },
}));

const Comments = ({ objectType, objectId }) => {
    const classes = useStyles();

    const [comments, setComments] = React.useState([]);
    const [addedComments, setAddedComments] = React.useState([]);
    const getUrl = () => `${config.BACK_API}/api/${objectType}/${objectId}/comment`
    useEffect(() => {
        httpUtils.get(getUrl(), { limit: 5 }).then((response) => {
            setComments(response.data.results);
        })
    }, [objectId]);

    const load = async () => {
        dispatch(types.SET_LOADER);
        let newestCommentId;
        if (comments.length > 0) {
            newestCommentId = comments[comments.length - 1].id
        }
        const response = await httpUtils.get(getUrl(), { limit: 5, newestCommentId });
        const newComments = [...comments, ...response.data.results];
        setComments(newComments);
        setAddedComments(addedComments.filter(nc => !newComments.find(c => c.id === nc.id)));
        dispatch(types.UNSET_LOADER);
    }

    const onDelete = (comment) => {
        setComments(comments.filter(c => c.id !== comment.id))
    }

    const onAddComment = (comment) => {
        setAddedComments([...addedComments, comment]);
    }

    return (
        <>
            <div className={classes.messages}>
                {comments.map((comment) => (
                    <Comment objectType={objectType} objectId={objectId} comment={comment} requestUrl={getUrl()} onDelete={onDelete} />
                ))}
                <Button variant="contained" onClick={load}>Load more</Button>
                {addedComments.map((comment) => (
                    <Comment objectType={objectType} objectId={objectId} comment={comment} requestUrl={getUrl()} onDelete={onDelete} />
                ))}
                <AddComment objectType={objectType} objectId={objectId} onAdd={onAddComment} />
            </div>
        </>
    )
}

export default Comments;